import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step4({ prevStep, nextStep, updateFieldValue, value }) {

    const [kind, setKind] = useState(value);
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (kind === "") {
            showError(true)
        } else {
            updateFieldValue("taxDebtKind", kind);
            nextStep(4)
        }
    }

    const handleForward = (v) => {
        setKind(v)
        updateFieldValue("taxDebtKind", v);
        nextStep(4)
    }

    return (

        <div id="step4">
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-6'>What kind of tax debt do you need help with?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <div className='py-1'>
                            <input type="radio" id="taxDebtKind-1" defaultChecked={value === "Most of my tax debt is income tax (personal or business)"} onClick={() => handleForward("Most of my tax debt is income tax (personal or business)")} name="what_kind_of_tax_debt_do_you_need_help_with_" value="Most of my tax debt is income tax (personal or business)" />
                            <label htmlFor="taxDebtKind-1" className='ml-2'>Most of my tax debt is income tax (personal or business)</label>
                        </div>
                        <div className='py-1'>
                            <input type="radio" id="taxDebtKind-2" defaultChecked={value === "My tax debt is mostly property tax"} onClick={() => handleForward("My tax debt is mostly property tax")} name="what_kind_of_tax_debt_do_you_need_help_with_" value="My tax debt is mostly property tax" />
                            <label htmlFor="taxDebtKind-2" className='ml-2'>My tax debt is mostly property tax</label>
                        </div>
                        <div className='py-1'>
                            <input type="radio" id="taxDebtKind-3" defaultChecked={value === "My tax debt is mostly unemployment tax"} onClick={() => handleForward("My tax debt is mostly unemployment tax")} name="what_kind_of_tax_debt_do_you_need_help_with_" value="My tax debt is mostly unemployment tax" />
                            <label htmlFor="taxDebtKind-3" className='ml-2'>My tax debt is mostly unemployment tax</label>
                        </div>
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep4Prev"
                    onClick={() => prevStep(4)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    4 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep4Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>
        </div>
    );
}